var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pagehead" },
    [
      _vm.userInfo.token && !_vm.isNotBuzzCast() ? _c("addscreen") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "fc-bg-fff fc-pad-lr" }, [
        _c("p", { staticClass: "recharge_title" }, [
          _vm._v(_vm._s(_vm.$t("m.Diamonds_title", { msg: _vm.getAppName() })))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "fc-pad-r fc-flex fc-flex-vcenter" }, [
          _c("img", {
            staticClass: "user_photo avater",
            attrs: {
              src:
                _vm.userInfo.img ||
                require("../assets/img/h5_recharge_head.png")
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "fc-flex1 fc-mar-lr-sm" }, [
            _c(
              "p",
              {
                staticClass: "fc-text-big fc-elip-1 fc-text-bold",
                staticStyle: { "max-width": "3rem" }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.userInfo.nickName || _vm.$t("m.login_no"))
                )
              ]
            ),
            _vm._v(" "),
            !_vm.isInBondo
              ? _c("p", { staticClass: "fc-text-usual fc-mar-t-min" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.userInfo.userId
                          ? "ID:" + _vm.userInfo.userId
                          : _vm.$t("m.login_after_recharge")
                      )
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.userInfo.userId
            ? _c(
                "div",
                {
                  staticClass: "fc-btn-line-main",
                  on: { click: _vm.exitLogin }
                },
                [_vm._v(_vm._s(_vm.$t("m.logout")))]
              )
            : _c(
                "div",
                {
                  staticClass: "fc-btn-line-main",
                  on: { click: _vm.enterLogin }
                },
                [_vm._v(_vm._s(_vm.$t("m.login")))]
              )
        ]),
        _vm._v(" "),
        _vm.isInBondo
          ? _c("div", { staticClass: "bondo-pay-tip" }, [
              _vm._v("\n      " + _vm._s(_vm.$t("m.bondo_pay_tip")) + "\n    ")
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c700d7f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c700d7f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pagehead.vue
// module id = null
// module chunks = 